// 产品信息
export const PRODUCT_NAME = '轻派筛查系统后台';
export const PRODUCT_DESC = '';
export const COMPANY_NAME = '轻派科技';

export const API = 'https://api.qpsc365.com'
